import request from "../utils/request";
import store from "@/store/store";

export async function GetPaged(payload) {
    return request.get("BranchWalletTransaction/GetPaged?", {
      params: {
        sortBy: payload.sortBy,
        sortDirection: payload.sortDirection,
        pageIndex: payload.pageIndex,
        pageSize: payload.pageSize,
        branchId: payload.branch != null || payload.branch != undefined ? payload.branch.id : null,
        startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
        startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
        endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
        endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
        type: payload.walletOffSetType!=null ? payload.walletOffSetType.id: null
      }
    });
  }
export async function createOffSet(data) {
    return request.post("BranchWalletTransaction/CreateWalletPayment", data);
  }

  export async function updateOffSet(data) {
    return request.post("BranchWalletTransaction/UpdateWalletPayment", data);
  }

  export async function GetBalance(branchId) {
    return request.get("BranchWalletTransaction/GetBalance?branchId="+branchId);
  }

  export async function getExcel(payload) {
    return request.get("BranchWalletTransaction/GetExcel", {
      params: {
        startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
        endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null
      },
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.ms-excel'
      }
    })
  }

  export async function getAll(payload) {
    return request.get("BranchWalletTransaction/GetAll", {
      params: {
        startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
        endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null
      }
    })
  }